import { useState } from 'react'

import { PrebidModuleParameter } from 'features/globalSetup/types/prebidModule'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_PREBID_MODULE_PARAMETERS_SCHEMA } from './api/query'
import { Data, Variables } from './api/types'
import { Props, UseGetPrebidModuleParameters } from './types'

export const useGetPrebidModuleParametersSchema = ({ id }: Props): UseGetPrebidModuleParameters => {
  const [parametersSchema, setParametersSchema] = useState<PrebidModuleParameter[]>([])

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const { node: prebidModule } = data
      if (prebidModule) {
        setParametersSchema(fromDTO(prebidModule.paramsSchema))
      }
    },
    options: { enabled: !!id },
    query: GET_PREBID_MODULE_PARAMETERS_SCHEMA,
    variables: { id },
  })

  return { loading, parametersSchema }
}
